import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "YOUR_API_KEY",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "hrms-42b9a.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "hrms-42b9a",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "hrms-42b9a.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "1099076307936",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:1099076307936:web:b2691a8dcef4ea44d03985",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-1MJ8G0RRSQ",
};

const hasFirebaseConfig = firebaseConfig.apiKey && firebaseConfig.apiKey !== "YOUR_API_KEY";

const firebaseApp = hasFirebaseConfig ? initializeApp(firebaseConfig) : null;
const messaging = firebaseApp ? getMessaging(firebaseApp) : null;

export { firebaseApp, messaging, firebaseConfig, hasFirebaseConfig };
